import {
  Avatar,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from '@mui/material';
import { Icon48Jobs, Icon48SMB, Icon48DaycareCenters } from '@care/react-embrace-icons';
import { useResponsive } from '@/components/hooks/useResponsive';

export const SMBHowItWorks = () => {
  const { isMediumViewport } = useResponsive();

  const stats = [
    {
      Icon: Icon48Jobs,
      label: `Share details about your daycare needs`,
    },
    {
      Icon: Icon48SMB,
      label: `Match with highly rated local daycares near you`,
    },
    {
      Icon: Icon48DaycareCenters,
      label: `Compare daycares and tour the ones that best fit your family`,
    },
  ];
  return (
    <Box mt={{ xs: 4, md: 0 }} ml={{ xs: 3, sm: 0, md: 3 }} maxWidth={{ xs: '300px', sm: '100%' }}>
      <Typography variant="h2">How it works</Typography>
      <List
        sx={{
          display: { xs: 'block', sm: 'flex', md: 'block' },
          mt: 3,
        }}>
        {stats.map(({ Icon, label }) => (
          <ListItem
            disableGutters
            sx={{
              py: 0,
              mx: 0,
              mt: { xs: 2, sm: 0, md: 2 },
              mr: { xs: undefined, sm: 4, md: undefined },
              '&:first-of-type': { mt: 0 },
            }}
            key={label}>
            <ListItemAvatar sx={{ mr: { xs: 3, sm: 2, md: 3 } }}>
              <Avatar
                sx={{
                  bgcolor: 'background.accent.accent3',
                  height: '64px',
                  width: '64px',
                }}>
                <Icon size="40px" color="text.primary" />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              secondaryTypographyProps={{
                color: 'text.primary',
                variant: isMediumViewport ? 'body3' : 'body2',
              }}
              secondary={label}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
